import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Image, Stack, Text, rem } from '@mantine/core';
export const InfoPhoneVerifySuccess: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack align="center" gap={0}>
      <Image src="/assets/profile/phone_success.svg" w={180} h={180} mb={36} mx="auto" />
      <Text fz={{
      base: rem(20),
      sm: rem(36),
      lg: rem(25)
    }} lh={rem(36)} className={gunterzBold.className} c="var(--text-prime)">
        {i18n._('Verified')}
      </Text>
      <Text fz="xs" w={287} fw={700} ta="center" tt="uppercase" mt={{
      sm: 12,
      lg: 0
    }} c="var(--text-dark)">
        {i18n._('Your phone number has been successfully verified!')}
      </Text>
    </Stack>;
};